import { Field, FieldArray, FormikProps } from 'formik';
import * as React from 'react';

import FormikRadioInput from '../input-radio';
import { AvailabilityFormData, TwsAdmin } from './types';
import { arrayToRows } from '../../utils/arrays';
import TextArea from '../input-textarea';
import CheckboxInput from '../input-checkbox';

interface OwnProps {
    choicesLoaded: boolean | null;
    choicesData: TwsAdmin.AvailabilityFormChoices | null;
    valuesLoaded: boolean | null;
    formikProps: FormikProps<AvailabilityFormData>;
}

export default class AvailabilityGeneralCard extends React.Component<OwnProps> {
    constructor(props: OwnProps) {
        super(props);
    }

    render() {
        const { choicesLoaded, choicesData, valuesLoaded, formikProps } = this.props;

        const dataFullyLoaded = choicesLoaded && !!choicesData && valuesLoaded;

        const months = Array.from({ length: 12 }, (item, i) => {
            return new Date(0, i).toLocaleString('en-US', { month: 'long' });
        });

        const monthChoices = months.map((month, idx) => ({ value: idx + 1, label: month }));

        const seasonAvailabilityError =
            typeof formikProps.errors.season_availability === 'string' ? formikProps.errors.season_availability : null;

        const peakMonthsError = typeof formikProps.errors.peak_month_override === 'string' ? formikProps.errors.peak_month_override : null;

        return (
            <div className='VenueManagement--card VenueManagement--availabilitygeneral'>
                <div className='VenueManagement--card--header'>General</div>

                {((choicesLoaded && !choicesData) || valuesLoaded === false) && (
                    <div className='VenueManagement--card--body VenueManagement--form-level-error'>
                        Could not load form data, please try again later
                    </div>
                )}

                {dataFullyLoaded && (
                    <div className='VenueManagement--card--body'>
                        {!!choicesData && (
                            <div className='VenueManagement--row VenueManagement--availabilitygeneral--season'>
                                <span className='VenueManagement--availabilitygeneral--radio-lbl'>
                                    Venue is available:
                                    {!!seasonAvailabilityError && (
                                        <div className='VenueManagement--form-level-error'>{seasonAvailabilityError}</div>
                                    )}
                                </span>
                                <span className='VenueManagement--availabilitygeneral--radio-group'>
                                    {choicesData.season_availability.choices.map((item, idx) => (
                                        <Field
                                            key={idx}
                                            component={FormikRadioInput}
                                            name='season_availability'
                                            value={`${item.value}`}
                                            label={item.label}
                                            hideErrors={true}
                                            checked={`${item.value}` === formikProps.values.season_availability}
                                        />
                                    ))}
                                </span>
                            </div>
                        )}

                        <div className='VenueManagement--availabilitygeneral--peak-months'>
                            <div className='VenueManagement--availabilitygeneral--peak-months-lbl'>Select on-peak months:</div>
                            {!!peakMonthsError && <div className='VenueManagement--form-level-error'>{peakMonthsError}</div>}
                            <div className='VenueManagement--card--section'>
                                <div>
                                    <FieldArray
                                        name='peak_month_override'
                                        render={(arrayHelpers) => {
                                            return arrayToRows(monthChoices).map((row, rowIdx) => (
                                                <div key={rowIdx} className='VenueManagement--row'>
                                                    {row.map((col, colIdx) => (
                                                        <div key={colIdx} className='VenueManagement--col'>
                                                            {!!col && (
                                                                <Field
                                                                    label={col.label}
                                                                    component={CheckboxInput}
                                                                    name={`peak_month_override.${col.value - 1}`}
                                                                    value={col.value}
                                                                    checked={formikProps.values.peak_month_override.indexOf(col.value) > -1}
                                                                    onChange={(e: React.SyntheticEvent<HTMLInputElement>) => {
                                                                        if ((e.target as HTMLInputElement).checked) {
                                                                            arrayHelpers.push(col.value);
                                                                        } else {
                                                                            const idx = formikProps.values.peak_month_override.indexOf(
                                                                                col.value
                                                                            );
                                                                            arrayHelpers.remove(idx);
                                                                        }
                                                                    }}
                                                                    hideErrors={true}
                                                                />
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            ));
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='VenueManagement--row VenueManagement--availabilitygeneral--venuenotes'>
                            <div className='VenueManagement--textarea-container'>
                                <Field label='Venue notes' component={TextArea} name='availability_description' />
                            </div>
                        </div>
                        <div className='VenueManagement--row'>
                            <div className='VenueManagement--col'>
                                <div className='VenueManagement--helptext'>
                                    Example description 1:
                                    <br />
                                    The rental fee ranges from $1,500 to $5,400 for a reception and includes 6 hours of event time excluding
                                    set up and clean up time. The set up fee for a ceremony is $1,000 with reception rental or $2,000 for a
                                    ceremony only wedding. Additional hours can be arranged for a fee of $1,000/hr. A refundable security
                                    deposit of $500 is required.
                                </div>
                            </div>
                            <div className='VenueManagement--visible-col-divider' />
                            <div className='VenueManagement--col'>
                                <div className='VenueManagement--helptext'>
                                    Example description 2:
                                    <br />
                                    There is no rental fee for the reception but there is a food and beverage minimum applied to all events.
                                    The venue allows 6 hours of event time excluding set up and clean up time. The set up fee for a wedding
                                    ceremony is $1,500 and includes an extra hour of event time. Additional hours can be arranged for a fee
                                    of $250/hr. A refundable security deposit of $500 is required.
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
